import { render, staticRenderFns } from "./sage-reports.vue?vue&type=template&id=da77ed5e&"
import script from "./sage-reports.vue?vue&type=script&lang=js&"
export * from "./sage-reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports